import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { ZeroMatchingInquiresRoutes  } from '../../../routes';

export const ZeroMatchingInquiresLayout = () => <SwitchRoute routes={ZeroMatchingInquiresRoutes} />;
